import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Alternative Facts Division',
		description:
			'Create a department dedicated to inventing facts from parallel universes.'
	},
	{
		name: 'Reality Distortion Field',
		description:
			'Install special lenses that make everything look more dramatic than it is.'
	},
	{
		name: 'Clickbait AI',
		description:
			"Deploy AI that turns every headline into shocking clickbait. You won't believe #7!"
	},
	{
		name: 'Quantum News Generator',
		description:
			'News stories exist in all possible states until someone reads them.'
	},
	{
		name: 'Time-Traveling Headlines',
		description:
			'Report news from tomorrow, yesterday, and alternate timelines simultaneously.'
	},
	{
		name: 'Multiverse News Network',
		description:
			'Broadcast news from infinite parallel universes. Reality optional.'
	},
	{
		name: 'Void Broadcasting',
		description:
			'Transmit news directly from the void. Static never looked so convincing.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Fake News Network'],
	departments[DepartmentIds['Fake News Network']].basePrice * 3,
	UpgradeIds.FnnExponent1
)

export default array
